import { Box, Divider, Grid, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import CustomLabel from "../../scenes/posture/frameworks/components/CustomLabel";

const POCTooltip = ({ pocLimits }) => {
  const colors = useColors();

  return (
    <Box>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          maxWidth: "100%",
        }}
      >
        <Grid container justifyContent="center" alignItems="center">
          <Typography variant="overline" style={{ lineHeight: "18px" }}>
            TRIAL
          </Typography>
        </Grid>
      </Box>
      <Divider sx={{ marginY: 1 }} />
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ marginTop: "8px", marginBottom: "8px" }}
      >
        <Typography variant="caption" style={{ color: colors.text_secondary }}>
          Views Remaining
        </Typography>
      </Grid>
      <Grid container>
        <Grid item xs={6}>
          <CustomLabel
            colorFamily={"black"}
            severity={"default"}
            labelType="soft"
            size="small"
            text="Today"
          />
        </Grid>
        <Grid item xs={6} style={{ textAlign: "right" }}>
          <Typography variant="caption">
            {pocLimits.viewed_remaining_today} /{" "}
            {pocLimits.daily_controls_limit}
          </Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={6}>
          <CustomLabel
            colorFamily={"black"}
            severity={"default"}
            labelType="soft"
            size="small"
            text="Total"
          />
        </Grid>
        <Grid item xs={6} style={{ textAlign: "right" }}>
          <Typography variant="caption">
            {pocLimits.total_controls_limit - pocLimits.total_controls_viewed} /{" "}
            {pocLimits.total_controls_limit}
          </Typography>
        </Grid>
      </Grid>
      {/* TODO Days Remaining */}
      {/*
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ marginTop: "16px" }}
      >
        <Typography variant="caption" style={{ color: colors.text_secondary }}>
          Days Remaining
        </Typography>
      </Grid>
      */}
    </Box>
  );
};

export default POCTooltip;
